import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ChangedFieldsCell as GenericChangedFieldsCell } from '@/modules/common/components/changed-fields';

import { TeamMemberChangeLogEntry } from '../../types/team-member-changes';
import { createTeamChangedFieldsStrategy } from './team-changed-fields.strategy';

interface ChangedFieldsCellProps {
  entry: TeamMemberChangeLogEntry;
}

/**
 * Team-member-specific "Changed Fields" cell. Thin wrapper that feeds the
 * team field list and strategy into the shared generic cell.
 */
export const ChangedFieldsCell = ({ entry }: ChangedFieldsCellProps) => {
  // Subscribe to i18n so the memoized strategy rebuilds on language change.
  const { i18n } = useTranslation('authenticated.team');
  const strategy = useMemo(() => createTeamChangedFieldsStrategy(), [i18n.language]);

  return (
    <GenericChangedFieldsCell
      fields={entry.changedFields}
      strategy={strategy}
      isInitial={entry.isInitialChange}
    />
  );
};
